import classNames from 'classnames';
import { ReactNode } from 'react';

import useElementSize from '../../hooks/useElementSize';

import * as wrappers from './wrappers';

export interface AdWrapperProps {
    wrapper?: Record<string, unknown> | null;
    children: ReactNode;
    className?: string | null;
    innerClassName?: string | null;
    transformClassName?: string | null;
}

function AdWrapper({
    wrapper = null,
    children,
    className = null,
    innerClassName = null,
    transformClassName = null,
}: AdWrapperProps) {
    const { ref: innerRef, width: innerWidth, height: innerHeight } = useElementSize();
    const { wrapper: wrapperType = null } = wrapper || {};
    const wrapperFunc = wrapperType !== null ? wrappers[wrapperType] || null : null;
    const {
        innerChildren,
        innerStyle,
        style,
        transformStyle,
        className: wrapperClassName,
        innerClassName: wrapperInnerClassName,
        transformClassName: wrapperTransformClassName,
    } = wrapperFunc !== null
        ? wrapperFunc(wrapper, {
              innerWidth,
              innerHeight,
          }) || {}
        : {};
    return (
        <div className={classNames([className, wrapperClassName])} style={style}>
            <div
                className={classNames([innerClassName, wrapperInnerClassName])}
                ref={innerRef}
                style={innerStyle}
            >
                {innerChildren}
                <div
                    className={classNames([transformClassName, wrapperTransformClassName])}
                    style={transformStyle}
                >
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AdWrapper;
